import { PunchupEditEventForm } from './PunchupEditEventForm';
import { useEditEventApi } from './useEditEvent';

const PunchupEditEvent = () => {
	const { event, editEvent } = useEditEventApi();

	if (!event) {
		return null;
	}

	return <PunchupEditEventForm event={event} editEvent={editEvent} />;
};

export { PunchupEditEvent };
